import { request } from '@/api/request'

export const getApkUrl = async () => {
  const { data } = await request.get('/webapi/serve/static/bin/arcaea/apk')

  return data.value
}